module.exports = __webpack_public_path__ + "img/cover-redeem-bg.170d7863.jpg";